<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <li class="nav-item">
        <locale-selector />
      </li>
      <b-nav-item-dropdown
        v-if="userData && userData.email"
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav text-right custom-user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.name }}
            </p>
            <span class="user-status text-muted small">
              {{ userData.role_text }}
              <span
                v-if="userData.department !== null && userData.department !== undefined"
                class="text-primary mx-25"
              >•</span>
              {{ systemLabel(departmentMap[userData.department] || userData.department) }}
            </span>
          </div>
        </template>

        <b-dropdown-header class="dropdown-header-identity py-1">
          <div class="mb-50">
            <small class="text-muted d-block line-height-1 mb-25">{{ $t('common.publisher') }}</small>
            <span class="font-weight-bolder text-dark">{{ userData.company_name }}</span>
          </div>

          <b-dropdown-divider />

          <div class="mt-50">
            <small class="text-muted d-block line-height-1 mb-25">{{ $t('common.emailAddress') }}</small>
            <span class="user-email-text font-weight-bold">{{ userData.email }}</span>
          </div>
        </b-dropdown-header>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>{{ $t('common.logout') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BDropdownItem, BDropdownHeader, BDropdownDivider, BLink, BNavbarNav, BNavItemDropdown,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import LocaleSelector from '@core/layouts/components/app-navbar/components/Locale.vue'
import { systemLabel } from '@/libs/i18n/display'

export default {
  components: {
    LocaleSelector,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      departmentMap: {
        0: 'Business',
        1: 'Tech',
        2: 'Finance',
        3: 'Other',
      },
    }
  },
  computed: {
    userData() {
      return this.$store.getters['auth/appActiveUser'] || {}
    },
  },
  methods: {
    systemLabel,
    logout() {
      this.$store.dispatch('auth/logout')
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown-user {
  ::v-deep .dropdown-user-link {
    padding-right: 2.2rem !important;
    display: flex;
    align-items: center;
  }

  ::v-deep .dropdown-menu {
    min-width: 260px;
    padding: 0;
  }

  .custom-user-nav {
    line-height: 1.2;
    padding-right: 0.5rem;
  }

  .dropdown-header-identity {
    background-color: #f8f8f8;
    padding: 1rem;
    border-top-left-radius: 0.358rem;
    border-top-right-radius: 0.358rem;

    .user-email-text {
      color: #7367f0;
      display: block;
      word-break: break-all;
      white-space: normal;
    }
  }
}
</style>
